import React from 'react';

import { EditProps, required, SimpleForm, TextInput } from 'react-admin';

import { Edit } from 'components/organisms';

export const CountryEdit: React.FC<EditProps> = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="name" validate={required()} />
      <TextInput source="shortCode" />
      <TextInput
        fullWidth
        multiline
        rowsMax={15}
        source="regions"
        validate={required()}
      />
    </SimpleForm>
  </Edit>
);
